/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface LoanInsuranceFee { 
    id?: number;
    providerName?: string | null;
    logoUrl?: string | null;
    description?: string | null;
    feeAmount?: number;
    feeCollectionType?: number;
    status?: string | null;
}

